<template>
  <div class="page-box">
    <!--查询条件 -->
    <query-condition-box class="header">
      <datePicker :hasCurrent="1" @changeDate="changeDate"></datePicker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportList"
        >导出
      </el-button>
    </query-condition-box>
    <!-- 列表展示 -->
    <div class="result-container" v-loading="loading">
      <!-- 数据统计模块 -->
      <dataStatistics
        :type="'user'"
        :showInfo="showInfo"
        @changeData="changeShow"
      ></dataStatistics>
      <div id="main"></div>
    </div>
  </div>
</template>

<script>
import api from "@/assets/js/api";
import * as echarts from "echarts";
import dataStatistics from "../../components/operate/data-statistics.vue";
import datePicker from "../../components/common/date-picker.vue";
export default {
  name: "ShopCenterAdminWebUserData",

  data() {
    return {
      //查询参数
      queryParams: {
        from: "",
        to: "",
      },
      showType: 0, // 类型筛选项 5-店铺访客数 12-新增粉丝数 13-取关粉丝数 14-净增粉丝数 15-累计粉丝数
      loading: false,
      showInfo: [],
      shopVisitorCntList: [], // 店铺访客数数据列表
      addAttentionCntList: [], // 新增粉丝数数据列表
      cancelAttentionCntList: [], // 取关粉丝数数据列表
      increaseAttentionCntList: [], // 净增粉丝数数据列表
    };
  },
  components: {
    dataStatistics,
    datePicker,
  },
  computed: {
    // 店铺或工作室
    shopOrStudioTag() {
      return this.$store.getters["user/shopOrStudioTag"];
    },
    // 线形图名称
    lineNames() {
      return {
        5: `${this.shopOrStudioTag}访客数`,
        12: "新增粉丝数",
        13: "取关粉丝数",
        14: "净增粉丝数",
        15: "累计粉丝数",
      };
    },
  },
  mounted() {},
  methods: {
    // 切换时间段
    changeDate(e) {
      this.queryParams.from = e.startTime;
      this.queryParams.to = e.endTime;
      this.showType = 0;
      this.queryList();
    },
    // 切换线形图显示的数据
    changeShow(e) {
      // console.log("切换显示的数据为---", e);
      this.showType = e.id1;
      switch (this.showType) {
        case 5:
          this.showData(this.shopVisitorCntList);
          break;
        case 12:
          this.showData(this.addAttentionCntList);
          break;
        case 13:
          this.showData(this.cancelAttentionCntList);
          break;
        case 14:
          this.showData(this.increaseAttentionCntList);
          break;
      }
    },
    // 获取店铺列表相关数据
    async queryList() {
      this.loading = true;
      const { result } = await this.$axios.post(
        api.dataAnalysis.getUserData,
        this.queryParams
      );
      if (result) {
        const {
          shopVisitorCnt,
          shopVisitorCntList,
          addAttentionCnt,
          addAttentionCntList,
          cancelAttentionCnt,
          cancelAttentionCntList,
          increaseAttentionCnt,
          increaseAttentionCntList,
          currentAttentionCnt,
        } = result;
        this.shopVisitorCntList = shopVisitorCntList;
        this.addAttentionCntList = addAttentionCntList;
        this.cancelAttentionCntList = cancelAttentionCntList;
        this.increaseAttentionCntList = increaseAttentionCntList;
        // 数据统计模块展示的数据
        this.showInfo = [
          shopVisitorCnt,
          addAttentionCnt,
          cancelAttentionCnt,
          increaseAttentionCnt,
          currentAttentionCnt,
        ];
      }
      this.loading = false;
    },

    // 渲染图表
    showData(dataList) {
      let myChart = echarts.getInstanceByDom(document.getElementById("main"));
      if (!myChart) {
        myChart = echarts.init(document.getElementById("main"));
      }
      var option;
      option = {
        title: {
          text: "趋势图",
          left: "8%",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          data: dataList.map((item) => item.time),
        },
        yAxis: {},
        series: [
          {
            data: dataList.map((item) => item.value),
            type: "line",
            name: this.lineNames[this.showType],
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 导出数据
    exportList() {
      window.open(
        `https://shopcenter.xkw.com/${api.dataAnalysis.exportData}?from=` +
          this.queryParams.from +
          "&to=" +
          this.queryParams.to +
          "&shopId=" +
          this.$store.state.user.userInfo.shopId +
          "&dataType=9" +
          "&shopType=" +
          this.$store.state.user.userInfo.shopTypeId
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
#main {
  height: 500px;
}
.result-container {
  padding: 54px 20px 25px;
  background: #fff;
  border-radius: 5px;

  #main {
    margin-top: 80px;
  }
}
</style>
